import { acceptHMRUpdate, defineStore } from 'pinia'
import api from '@api'
import type { Addresses, AddressesListParams, AddressTimeSlotSettings } from '@apiTypes'

export const useAddressesStore = defineStore('addresses', {
  actions: {
    fetchAddresses(query: AddressesListParams) {
      return api.addresses.addressesList(query)
    },
    fetchAddress(id: number) {
      return api.addresses.addressesRetrieve({ id })
    },
    addAddress(data: Addresses.AddressesCreate.RequestBody) {
      return api.addresses.addressesCreate(data)
    },
    updateAddress(id: number, params: Addresses.AddressesPartialUpdate.RequestBody) {
      return api.addresses.addressesPartialUpdate({ id }, params)
    },
    deleteAddress(id: number) {
      return api.addresses.addressesDestroy({ id })
    },
    fetchTimeSlotSettings(addressId: number) {
      return api.addresses.addressesTimeSlotSettingsList({ addressPk: addressId })
    },
    createTimeSlotSettings(addressId: number, payload: AddressTimeSlotSettings) {
      return api.addresses.addressesTimeSlotSettingsCreate({ addressPk: addressId }, payload)
    },
    updateTimeSlotSettings(addressId: number, settingsId: number, payload: AddressTimeSlotSettings) {
      return api.addresses.addressesTimeSlotSettingsUpdate({ addressPk: addressId, id: settingsId }, payload)
    },
    fetchVehicleTypes() {
      return api.vehicleTypes.vehicleTypesList({})
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useAddressesStore, import.meta.hot))
